import $ from 'jquery';
import AsyncView from 'shopify-asyncview';

import Modal from './Modal';
import ProductDetails from './ProductDetails';
import RichText from './RichText';
import { initShopifyProductReviews } from '../helpers/ProductReviews';
import { setupRippleEffect } from '../helpers/Ripple';

export default class ProductQuickshop {
  constructor(options) {
    this.$el = options.$el;
    this.id = options.id;
    this.initialVariant = options.initialVariant || null;
    this.quickShopSelector = `#shopify-section-${this.id} [data-product-quickshop]`;
    this.$quickShop = $(this.quickShopSelector);
    this.quickshopSpinner = this.$quickShop[0].querySelector('.quickshop-spinner');
    this.modalClass = options.modalClass;
    this.loaded = false;
    this.richText = null;
    this.productDetails = null;
    this.trigger = options.trigger;
    this.isOpen = false;
    this.openingAddToCart = false;

    this.url = this.$el.data('product-quickshop-url');
    this.hash = this.$el.data('quickshop-hash');

    this.modalCallbacks = {
      onOpen: this._open.bind(this),
      onClose: this._close.bind(this),
    };

    this.atcCallbacks = {
      onInit: this._onATCInit.bind(this),
      onError: this._onATCError.bind(this),
      onSuccess: this._onATCSuccess.bind(this),
      onClose: this._onATCClose.bind(this),
    };

    this._initialize();
  }

  _initialize() {
    this.modal = new Modal(this.modalCallbacks);
    this.modal.open(
      this.quickShopSelector,
      this.modalClass,
    );
    this.isOpen = true;

    const $quickShopModalContent = this.modal.$modalInner.find('[data-modal-content]');

    AsyncView.load(
      this.url,
      { view: '_quickshop' },
      { hash: this.hash },
    ).then(({ html, data }) => {
      // Stop populating the modal if it was closed before the content was loaded
      if (!this.isOpen) { return; }

      $quickShopModalContent.html(html.content);

      initShopifyProductReviews();
      setupRippleEffect($quickShopModalContent[0]);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      this.$message = $quickShopModalContent.find('[data-product-quickshop-message]');
      this.$formArea = $quickShopModalContent.find('[data-product-form-area]');
      this.gallery = $quickShopModalContent[0].querySelector('[data-product-gallery]');
      this.$details = $quickShopModalContent.find('[data-product-details]');
      this.$description = $quickShopModalContent.find('[data-product-description]');
      this.context = data.context;
      this.settings = data.settings;
      this.product = data.product;

      this._onQuickshopLoaded();
    }).catch();
  }

  _onQuickshopLoaded() {
    if (this.loaded) {
      return;
    }

    if (this.$description && this.$description.length) {
      this.richText = new RichText(this.$description);
    }

    const options = {
      $formArea: this.$formArea,
      gallery: this.gallery,
      $details: this.$details,
      atcCallbacks: this.atcCallbacks,
      context: this.context,
      settings: this.settings,
      product: this.product,
      useHistory: false,
      isQuickshop: true,
      initialVariant: this.initialVariant,
    };

    this.modal.position();
    this.modal.finishedLoading();
    this.loaded = true;

    window.requestAnimationFrame(() => {
      this.productDetails = new ProductDetails(options);
    });
  }

  _open() {
    // do nothing
  }

  _close() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.richText) {
      this.richText.unload();
    }

    if (!this.openingAddToCart) {
      this.trigger.focus();
    }

    this.loaded = false;
    this.isOpen = false;
    this.$quickShop.empty();
    this.$quickShop.html(this.quickshopSpinner);
    this._toggleMessage('', false);
    this.modal.unload();
  }

  _toggleMessage(message, isVisible) {
    if (this.$message) {
      this.$message
        .html(message)
        .toggleClass('visible', isVisible);
    }
  }

  _onATCInit() {
    this.openingAddToCart = true;
    this.$message.removeClass('visible');
  }

  _onATCError(error) {
    const $content = $(`<div class="product-message--error" tabindex="-1">${error}</div>`);
    this._toggleMessage($content, true);
    $content.focus();
  }

  _onATCSuccess() {
    this._close();
  }

  _onATCClose() {
    // Do nothing
  }

  unload() {
    this._close();
  }
}
